const container = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  borderRadius: 2,
  alignItems: 'center',
};

const subContainerLeft = {
  display: 'inherit',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
};

const subContainerRight = {
  display: 'inherit',
  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
};

const icon = {
  display: 'inherit',
  cursor: 'pointer',
  padding: '8px',
};
const text = {
  wordBreak: 'break-word',
};

export { container, subContainerLeft, subContainerRight, icon, text };
